import React, { useState } from 'react';
import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

function ForgotPassForm({ crypted }) {
  const [password, setPassword]         = useState('');
  const [confPass, setConfPass]         = useState('');
  const [showPass, setShowPass]         = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');

  function handleSubmit() {
    const valid =
      password === confPass &&
      /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{6,}$/gm.test(password);

    if (valid) {
      fetch('/api/changepassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ password, email: crypted }),
      })
        .then(async (res) => {
          if (res.status === 401) {
            setConfirmMessage('');
            setErrorMessage(await res.text());
          }
          if (res.status === 200) {
            setErrorMessage('');
            setConfirmMessage(await res.text());
          }
        })
        .catch(err => console.log(err));
    } else {
      setConfirmMessage('');
      setErrorMessage('Les informations ne sont pas correctement renseignées');
    }
  }

  return (
    <div className="lf-root">
      <div className="lf-form">

        <div className="lf-field">
          <label htmlFor="fp-password" className="lf-field__label">Nouveau mot de passe</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
            <input
              type={showPass ? 'text' : 'password'}
              className="lf-field__input lf-field__input--pwd"
              id="fp-password"
              placeholder="Min. 6 car., lettres et chiffres"
              autoComplete="new-password"
              onChange={e => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="lf-field__toggle"
              onClick={() => setShowPass(s => !s)}
              aria-label={showPass ? 'Masquer' : 'Afficher'}
            >
              <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        <div className="lf-field">
          <label htmlFor="fp-confPass" className="lf-field__label">Confirmer le mot de passe</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
            <input
              type="password"
              className="lf-field__input"
              id="fp-confPass"
              placeholder="••••••••"
              autoComplete="new-password"
              onChange={e => setConfPass(e.target.value)}
            />
          </div>
        </div>

        <button type="button" className="lf-submit" onClick={handleSubmit}>
          Changer le mot de passe
        </button>

        {errorMessage   && <div className="lf-error"   role="alert">{errorMessage}</div>}
        {confirmMessage && <div className="lf-success">{confirmMessage}</div>}

        <p className="lf-switch">
          <Link to="/login" className="lf-switch__link">← Retour à la connexion</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassForm;
